module.exports = __webpack_public_path__ + "static/media/angle-down-double.172522e0.svg";